export default __webpack_public_path__ + "static/media/Samsung Galaxy S6 Edge+.e251cdb3.png";